import filterPriceSend from '../components/filter-price-send/init';

export default {
    init() {
        filterPriceSend();
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};


// WEBPACK FOOTER //
// ./scripts/routes/wooProductCatalog.js